import React from "react";
import { Route, Routes } from "react-router-dom";

import ROUTES_NAVIGATION from "./routes";
import JobCardList from "../components/DealerManagement/Services/JobCard/JobCardList";
import AddNewJobCard from "../components/DealerManagement/Services/JobCard/AddJobCard";
import TechnicianList from "../components/DealerManagement/Services/Tecnician/TechnicianList";
import TechnicianDetails from "../components/DealerManagement/Services/Tecnician/TechnicanDetails";
import SupervisorList from "../components/DealerManagement/Services/Supervisor/SupervisorList";
import JobCardDetails from "../components/DealerManagement/Services/JobCard/JobCardDetails";
import AddIssue from "../components/DealerManagement/Services/Tecnician/Addissue";
import SuperVisorDetails from "../components/DealerManagement/Services/Supervisor/SupervisorDetails";
import SupervisorPartList from "../components/DealerManagement/Services/SupervisorPartApproval/SupervisorPartList";
import SuperVisorPartDetails from "../components/DealerManagement/Services/SupervisorPartApproval/SupervisorPartDetails";
import SupervisorPartAllocationList from "../components/DealerManagement/Services/SparePartAllocation/SparPartAllocationList";
import SparePartAllocationDetails from "../components/DealerManagement/Services/SparePartAllocation/SparepartAllocationDetails";
import ServicesGetPassList from "../components/DealerManagement/Services/ServicesGetPass/ServicesGetPassList";
import ServicesGetPassDetails from "../components/DealerManagement/Services/ServicesGetPass/ServicesGetPassDetails";
import JobCardInvoicesList from "../components/DealerManagement/Services/JobCardInvoices/JobCardInvoicesList";
import JobInvoiceDetails from "../components/DealerManagement/Services/JobCardInvoices/JobCardInvoicesDetails";
import AddSurvayCard from "../components/DealerManagement/Services/JobCard/AddSurvay";
import AddJobCardIssue from "../components/DealerManagement/Services/JobCard/AddJobCardIssue";
import AddSupervisorAddIssue from "../components/DealerManagement/Services/Supervisor/AddSupervisorAddIssue";
import ADDSupervisorPartApprovalIssue from "../components/DealerManagement/Services/SupervisorPartApproval/SupervisorpartApprovalAddissueDetails";
import Dashboard from "../components/DealerManagement/Dashboard";
// import Survey from "../components/DealerManagement/Services/JobCard/Survey";
import PaymentInvoiceList from "../components/DealerManagement/Services/PaymentInvoice/PaymentInvoiceList";
import PaymentInvoiceDetails from "../components/DealerManagement/Services/PaymentInvoice/PaymentInvoiceDetails";
import ServiceDashboard from "../components/DealerManagement/Services/Dashboard";
import SurveyReport from "../components/DealerManagement/Services/JobCard/ServeyReport";
import Survey from "../components/DealerManagement/Services/JobCard/Survey";
import WarrantyClaims from "../components/DealerManagement/Services/WarrantyClaims";
import ExtendedWarranty from "../components/DealerManagement/Services/ExtendedWarranty";
import AddExtendedWarranty from "../components/DealerManagement/Services/ExtendedWarranty/AddExtendedWarranty/AddExtendedWarranty";
import PurchaseOrder from "../components/DealerManagement/Services/PurchaseOrder";
import WarrantyInspection from "../components/DealerManagement/Services/WarrantyInspection";
import WarrantyClaimsDetails from "../components/DealerManagement/Services/WarrantyClaims/WarrantyClaimsDetails";
import PurchaseOrderDetails from "../components/DealerManagement/Services/PurchaseOrder/PurchaseOrderDetail";
import EditJobCard from "../components/DealerManagement/Services/JobCard/EditJobCard";
import ReplacementAndRepair from "../components/DealerManagement/Services/ReplacementAndRepair";
import OrderManagementListService from "../components/DealerManagement/Admin/OrderManagement/indexService";

const ServiceRoutes = () => {
  return (
    <>
      <Route path={ROUTES_NAVIGATION.CHECKWARRANTY} element={<JobCardList />} />

      <Route
        path={ROUTES_NAVIGATION.WARRANTYCLAIMS}
        element={<WarrantyClaims />}
      />

      <Route
        path={ROUTES_NAVIGATION.WARRANTYCLAIMSDETAILS}
        element={<WarrantyClaimsDetails />}
      />

      <Route
        path={ROUTES_NAVIGATION.EXTENDEDWARRANTYSERVICE}
        element={<ExtendedWarranty />}
      />

      <Route
        path={ROUTES_NAVIGATION.ADDEXTENDEDWARRANTYSERVICES}
        element={<AddExtendedWarranty />}
      />

      <Route
        path={ROUTES_NAVIGATION.PURCHASEORDERSERVICE}
        element={<PurchaseOrder />}
      />

      <Route
        path={ROUTES_NAVIGATION.PURCHASEORDERDETAILSSERVICE}
        element={<PurchaseOrderDetails />}
      />

      <Route
        path={ROUTES_NAVIGATION.WARRANTYINSPECTION}
        element={<WarrantyInspection />}
      />

      <Route
        path={ROUTES_NAVIGATION.SERVICEDASHBOARD}
        element={<ServiceDashboard />}
      />
      <Route
        path={ROUTES_NAVIGATION.DASHBOARDSERVICE}
        element={<ServiceDashboard />}
      />
      <Route path={ROUTES_NAVIGATION.ADDJOBCARD} element={<AddNewJobCard />} />

      <Route path={ROUTES_NAVIGATION.EDITJOBCARD} element={<EditJobCard />} />

      <Route
        path={ROUTES_NAVIGATION.REPAIRREPLACEMEMT}
        element={<ReplacementAndRepair />}
      />

      <Route
        path={ROUTES_NAVIGATION.TECHNICIANLIST}
        element={<TechnicianList />}
      />
      <Route
        path={ROUTES_NAVIGATION.TECHNICIANDETAILS}
        element={<TechnicianDetails />}
      />
      <Route
        path={ROUTES_NAVIGATION.SUPERVISIONLIST}
        element={<SupervisorList />}
      />
      <Route
        path={ROUTES_NAVIGATION.JOBCARDDETAILS}
        element={<JobCardDetails />}
      />
      <Route path={ROUTES_NAVIGATION.ADDISSUE} element={<AddIssue />} />
      <Route
        path={ROUTES_NAVIGATION.SUPERVISIONDETAILS}
        element={<SuperVisorDetails />}
      />
      <Route
        path={ROUTES_NAVIGATION.SUPERVISIONPARTAPPROVAL}
        element={<SupervisorPartList />}
      />
      <Route
        path={ROUTES_NAVIGATION.SUPERVISIONPARTDETAILS}
        element={<SuperVisorPartDetails />}
      />
      <Route
        path={ROUTES_NAVIGATION.SPAREPARTALLOCATION}
        element={<SupervisorPartAllocationList />}
      />
      <Route
        path={ROUTES_NAVIGATION.SPAREPARTALLOCATIONDETAILS}
        element={<SparePartAllocationDetails />}
      />
      <Route
        path={ROUTES_NAVIGATION.SERVICEGETPASS}
        element={<ServicesGetPassList />}
      />
      <Route
        path={ROUTES_NAVIGATION.SERVICESGETPASSDETAILS}
        element={<ServicesGetPassDetails />}
      />
      <Route
        path={ROUTES_NAVIGATION.JOBCARDINVOICESLIST}
        element={<JobCardInvoicesList />}
      />
      <Route
        path={ROUTES_NAVIGATION.JOBCARDINVOICESDETAILS}
        element={<JobInvoiceDetails />}
      />

      <Route
        path={ROUTES_NAVIGATION.ADDJOBCARDISSUE}
        element={<AddJobCardIssue />}
      />
      <Route
        path={ROUTES_NAVIGATION.ADDSUPERVISORISSUE}
        element={<AddSupervisorAddIssue />}
      />
      <Route
        path={ROUTES_NAVIGATION.ADDSUPERVISORPARTAPPROVALISSUE}
        element={<ADDSupervisorPartApprovalIssue />}
      />
      <Route path={ROUTES_NAVIGATION.SURVEY} element={<Survey />} />
      <Route
        path={ROUTES_NAVIGATION.PAYMENTINVOICELIST}
        element={<PaymentInvoiceList />}
      />
      <Route
        path={ROUTES_NAVIGATION.PAYMENTINVOICEDETAILS}
        element={<PaymentInvoiceDetails />}
      />
      <Route path={ROUTES_NAVIGATION.SURVEYREPORT} element={<SurveyReport />} />
      {/* MANAGESERVICEORDER */}

      <Route
        path={ROUTES_NAVIGATION.MANAGESERVICEORDER}
        element={<OrderManagementListService />}
      />
    </>
  );
};

export default ServiceRoutes;
